import { createPresenceComponent, makeStyles, motionTokens } from "@fluentui/react-components";

const PresenceMotion = createPresenceComponent<{ isForward: boolean }>(({ isForward }) => {
    const leftInBound = [
        {
            opacity: 0,
            transform: "translateX(-100%)",
        },
        {
            opacity: 1,
            transform: "translateX(0)"
        },
    ];

    const rightInBound = [
        {
            opacity: 0,
            transform: "translateX(100%)",
        },
        {
            opacity: 1,
            transform: "translateX(0)"
        }
    ]

    const duration = motionTokens.durationSlow;
    const easing = motionTokens.curveEasyEase;

    let enterFrames = isForward ? rightInBound : leftInBound;
    let exitFrames = isForward ? leftInBound : rightInBound;

    return {
        enter: {
            keyframes: enterFrames,
            duration,
            easing,
        },
        exit: {
            keyframes: [...exitFrames].reverse(),
            duration,
            easing,
        },
    };
});

type BodyPresenceMotionProps = {
    isForward: boolean;
    visible: boolean;
    unmountOnExit: boolean;
    children: React.ReactNode;
};

const useStyles = makeStyles({
    root: {
        position: "absolute",
        top: "5px",
        left: "25px",
        right: "25px",
        // borderRadius: tokens.borderRadiusMedium,
        // border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
        // backgroundColor: tokens.colorNeutralBackground2,
        // boxShadow: tokens.shadow4,
        // padding: "10px",
    }
});

export default function BodyPresenceMotion({ isForward, visible, unmountOnExit, children }: BodyPresenceMotionProps) {
    const styles = useStyles();

    return (
        <PresenceMotion isForward={isForward} visible={visible} unmountOnExit={unmountOnExit}>
            <div className={styles.root}>
                {children}
            </div>
        </PresenceMotion>
    );
}
